import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Flex, Link, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react'
import React from 'react'
import { useProlongationDetailModalStore } from '../../store/modalsStore'
import UmSpinner from '../UI/UmSpinner'

function ProlongationDetailModal({isOpen, onClose}) {
    const prolongation = useProlongationDetailModalStore(state => state.prolongation)
    const setProlongation = useProlongationDetailModalStore(state => state.setProlongation)

    const clearAndClose = () => {
        setProlongation(null)
        onClose()
    }

    return (
        <Modal isOpen={isOpen} onClose={clearAndClose} size='xl'>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Подробная информация</ModalHeader>
                <ModalCloseButton />
                <ModalBody p='8px 24px 24px 24px'>
                    {prolongation
                    ?
                    <Flex direction='column' gap='8px'>
                        <Text>
                            <b>{`ID: `}</b>
                            <Link
                                isExternal
                                href={`https://old.umschool.net/predbannik/core/user/${prolongation?.umschool_id}`}
                            >
                                {prolongation?.umschool_id}
                            </Link>
                        </Text>
                        <Text>
                            <b>{`Имя: `}</b>
                            {prolongation?.student_name}
                        </Text>
                        <Text>
                            <b>{`Имя куратора/ПМ: `}</b>
                            <Link
                                isExternal
                                href={prolongation?.tutore_vk || ''}
                            >
                                {prolongation?.tutore_name || ''}
                            </Link>
                        </Text>
                        <Text>
                            <b>{`Приоритетный предмет: `}</b>
                            {prolongation?.selector_and_token_prev || ''}
                        </Text>
                        <Text>
                            <b>{`Дата первой покупки: `}</b>
                            {prolongation?.first_payment || ''}
                        </Text>
                        <Accordion defaultIndex={[0, 1, 2]} allowMultiple>
                            <AccordionItem>
                                <AccordionButton gap='8px' p='8px'>
                                    <AccordionIcon />
                                    <Box>
                                        Контакты
                                    </Box>
                                </AccordionButton>
                                <AccordionPanel gap='8px'>
                                    <Text>
                                        <b>{`Телефон ученика: `}</b>
                                        {prolongation?.user_phone || '-'}
                                    </Text>
                                    <Text>
                                        <b>{`Телефон родителя: `}</b>
                                        {prolongation?.parent_phone || '-'}
                                    </Text>
                                </AccordionPanel>
                            </AccordionItem>
                            <AccordionItem>
                                <AccordionButton gap='8px' p='8px'>
                                    <AccordionIcon />
                                    <Box>
                                        Цели
                                    </Box>
                                </AccordionButton>
                                <AccordionPanel gap='8px'>
                                    {prolongation.products.map(pr => (
                                        <Text>
                                            <b>{`${pr.subject}: `}</b>
                                            {pr?.goal_prev || '-'}
                                        </Text>
                                    ))}
                                </AccordionPanel>
                            </AccordionItem>
                            <AccordionItem>
                                <AccordionButton gap='8px' p='8px'>
                                    <AccordionIcon />
                                    <Box>
                                        Успеваемость
                                    </Box>
                                </AccordionButton>
                                <AccordionPanel gap='8px'>
                                    <Text>
                                        <b>{`Средняя просмотренность вебинаров: `}</b>
                                        {prolongation?.web_result_prev 
                                        ? `${Math.round(prolongation.web_result_prev * 100)}%` 
                                        : '-'}
                                    </Text>
                                    <Text>
                                        <b>{`Средний балл за ДЗ: `}</b>
                                        {prolongation?.hw_result_prev 
                                        ? `${Math.round(prolongation.hw_result_prev * 100)}%` 
                                        : '-'}
                                    </Text>
                                    {prolongation.products.map(pr => (
                                        <Text>
                                            <b>{`Средний балл ${pr.subject}: `}</b>
                                            {pr?.subject_and_score_prev || '-'}
                                        </Text>
                                    ))}
                                </AccordionPanel>
                            </AccordionItem>
                        </Accordion>
                    </Flex>
                    :
                    <UmSpinner />
                    }
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default ProlongationDetailModal
